module.exports = __webpack_public_path__ + "static/media/burger.0e2b392b.svg";